<template>
    <div>
        <ion-grid>
            <ion-row class="search-view">
                <ion-col>
                    <ion-label>Mobile No</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-input 
                        class="form-input" 
                        v-model="mobile"
                        type="text" 
                        id="mobile" 
                        @input="mobile = $event.target.value">
                        </ion-input>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>Select Branch</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            :value="branchId"
                            @ionChange="changeBranchName($event)"
                            placeholder="Select Dashboard"
                            interface="action-sheet"
                        >
                            <ion-select-option
                                v-for="(branchInfo, index) in this.branchList"
                            :key="index"
                            :value="branchInfo.branchId"
                            >{{branchInfo.corporateName}}, {{ branchInfo.branch }}</ion-select-option>
                        </ion-select>

                        <select
                            @change="changeBranchName($event)"
                            class="input-select select-web"
                            v-model="branchId"
                            placeholder="Select Status"
                        >
                            <option
                            v-for="(branchInfo, index) in this.branchList"
                            :key="index"
                            :value="branchInfo.branchId"
                            >{{branchInfo.corporateName}}, {{ branchInfo.branch }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>From Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportFrom"
                        :typeable="true"
                        :lowerLimit ="sixMonthsAgo"
                        :upperLimit ="currentDate"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportFrom" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select From Date"
                        @change="fromDateChanged($event)"
                        :value = reportFrom
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        :typeable="true"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>To Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportTo"
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="maxDate"
                        :typeable="true"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportTo" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select To Date"
                        @change="reportTo = $event.target.value"
                        :value = reportTo
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                <ion-col>
                    <div class="btn-srch-clr">
                        <ion-button class="btn-search " @click="searchReport">Search</ion-button>
                        <ion-button class="btn-clear " @click="clearFields">
                            <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row v-if="displayDownloadOption">
                <ion-col size="6"></ion-col>
                <ion-col size="6">
                    <div class="export-report">
                        <ion-label style="font-size: 14px;">Export Report</ion-label>
                        <div class="border-line-34 margin-top-10">
                            <ion-select
                                class="form-select select-mobile"
                                :value="reportType"
                                @ionChange="changeReportType($event)"
                                placeholder="Export Report"
                                interface="action-sheet"
                            >
                                <ion-select-option
                                    v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</ion-select-option>
                            </ion-select>

                            <select
                                @change="changeReportType($event)"
                                class="input-select select-web"
                                v-model="reportType"
                                placeholder="Export Report"
                            >
                                <option
                                v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</option>
                            </select>
                        </div>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row class="list-view" v-if="displayOverAllReport">
                <ion-col>
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                        <ion-label>S. No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Mobile No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Total kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(report, index) in this.overAllPageData" :key="index">
                        <ion-col size="12" size-md="2">
                        <ion-label class="ext-link">{{ report.sNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.name }}</ion-label>
                        </ion-col>
                    
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.mobile}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.totalkWh}}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col size="12" size-md="2"></ion-col>
                        <ion-col size="12" size-md="2"></ion-col>
                        <ion-col size="12" size-md="2" style="font-weight: bold;"><ion-label>Total kWh</ion-label></ion-col>
                        <ion-col size="12" size-md="2" ><ion-label>{{ overAllReport.totalKwh }}</ion-label> </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="list-view" v-if="displayUserBasedReport">
                <ion-col v-if="displayUserBasedReport">
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                        <ion-label>S. No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Mobile</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Start Date & Time</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>End Date & Time</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(report, index) in this.userBasedPageData" :key="index">
                        <ion-col size="12" size-md="2">
                        <ion-label class="ext-link">{{ report.sNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.name}}</ion-label>
                        </ion-col>
                    
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.mobile}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{(report.startDateTime)}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{(report.endDateTime)}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.kWh}}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col></ion-col>
                        <ion-col></ion-col>
                        <ion-col></ion-col>
                        <ion-col></ion-col>
                        <ion-col >
                            <ion-label>Total kWh </ion-label>
                        </ion-col>
                        <ion-col><ion-label>{{ userBasedReport.totalKwh }}</ion-label></ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>

        <div>
            <ion-grid>
                <ion-row>
                </ion-row>
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="ion-text-center">
                    <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-else>
                    <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a href="#" class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a href="#" class="prev disabled" v-else>Prev</a>
                        <a
                        href="#"
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        href="#"
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a href="#" class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>        
</template>

<script>
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner} from "@ionic/vue";
import { defineComponent } from "vue";
import { receiptOutline, refresh } from 'ionicons/icons';
import datepicker from 'vue3-datepicker';
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { migratedTryParseServiceError } from "../../service";
import { ValidationUtils } from "../../util/validation-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import jsonToCsvExport from "json-to-csv-export";

export default defineComponent({
    name: 'usageReport',
    components:{
        IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonIcon, IonGrid, IonRow, IonCol, IonSpinner, IonButton, IonLabel, datepicker, IonInput, IonSelect, IonSelectOption
    },
    data(){
        return{
            receiptOutline,
            refresh,
            loaderTab: true,
            reportFrom: new Date(),
            reportTo: new Date(),
            configDays: 0,
            configMonths: 0,
            // Calculate the minimum and maximum dates
            // minDate: this.calculateMinDate(),
            maxDate: new Date(), // Current date
            // The current date
            currentDate: new Date(),
            // Date 6 months ago
            sixMonthsAgo: new Date(),
            pageData: [],
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            branchId: "",
            mobile: '',
            branchList: [],
            displayUserBasedReport: false,
            displayOverAllReport: false,
            userBasedReport: [],
            overAllReport: [],
            userBasedPageData: [],
            overAllPageData: [],
            reportTypes: [
                {
                    "name" : "PDF",
                    "code" : "pdf"
                },
                {
                    "name" : "CSV",
                    "code" : "csv"
                }
            ],
            reportType: "",
            displayDownloadOption: false,
            configValue: []
        }
    },
    async mounted() {
        // this.reportFrom = moment().subtract(30, 'days').format('YYYY-MM-DD');
        // this.reportTo = moment().format('YYYY-MM-DD');
        
        this.loaderTab = false;
        await this.getDateAndMonth()
        await this.getDateDaysAgo(this.configDays)
        await this.getDateMonthsAgo(this.configMonths)
        await this.getBranchListForChart();
        await this.searchReport();
    },
    
    methods: {
        async getDateAndMonth() {
            this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
            this.configDays = this.configValue[0].description;
            this.configMonths = this.configValue[1].description
        },
        calculateMinDate() {
            const date = new Date();
            date.setMonth(date.getMonth() - 6);
            // alert(date)
            return date;
        },
        fromDateChanged(event) {
            // alert(event)
        },
        // Helper function to calculate a date 'n' days ago
        async getDateDaysAgo(days) {
            const date = new Date();
            date.setDate(date.getDate() - days);

            this.reportFrom =  date;
        },

        // Helper function to calculate the date 'n' months ago
        async getDateMonthsAgo(months) {
            const date = new Date();
            date.setMonth(date.getMonth() - months);
            this.sixMonthsAgo = date;
        },
        changeDateFormat(dateValue) {
            // return moment(dateValue).format('DD/MMM/YYYY HH:mm')
            return dateValue;
        },
        async changeBranchName(event) {
            this.branchId = event.target.value;
        },
        async getBranchListForChart() {
            this.branchList = [];
            this.loaderTab = true;
            try {
                this.branchList =  await new CorporateService().getBranchList();
                this.branchId = this.branchList[0].branchId;
                this.loaderTab = false;
                // this.getChargerStatus(this.branchId);
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        
        },
        async searchReport() {
            this.loaderTab = true;
            this.pageNo = 1;
            this.pageRecords = 10;
            this.reportType = "";
            this.displayDownloadOption = false;
            let dateRange =  (new Date(this.reportTo) - new Date(this.reportFrom));
            let dateRangeBetween = dateRange/(1000*60*60*24)
            if(this.reportFrom &&
                this.reportTo &&
                new Date(this.reportFrom) > new Date(this.reportTo)){
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select correct date range of Reoprt. From date should less than To date");
                this.displayUserBasedReport = false;
                this.displayOverAllReport = false;
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else if(dateRangeBetween > this.configDays) {
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select valid date range. The report can be viewed for a maximum of "+ this.configDays + " days");
                this.displayUserBasedReport = false;
                this.displayOverAllReport = false;
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else if(!this.mobile){
                try {
                    this.overAllReport = await new CorporateService().getUsageReportQuery({
                        branchId: this.branchId,
                        fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                        toDate: moment(this.reportTo).format('YYYY-MM-DD')

                    });
                    if(this.overAllReport.reportData.length > 0) {
                        this.totalRecords = this.overAllReport.reportData.length;
                        (this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                        )),
                        (this.totalPages = new PaginationUtils().getTotalPages(
                            this.totalRecords,
                            this.pageRecords
                        ));
                        let to = this.pageRecords*this.pageNo;
                        let from = (this.pageRecords * (this.pageNo -1));
                        this.overAllPageData = this.overAllReport.reportData.slice(from, to)
                        this.displayUserBasedReport = false;
                        this.displayOverAllReport = true;
                        this.displayDownloadOption = true;
                        this.norecordsfound = false;
                    } else {
                        this.displayUserBasedReport = false;
                        this.displayOverAllReport = false;
                        this.norecordsfound = true;
                        this.displayDownloadOption = false;
                    }
                    this.loaderTab = false;
                } catch(error) {
                    this.loaderTab = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }              
                
            } else if(new ValidationUtils().mobile(this.mobile) === false){
                new ToastUtils().presentToast("Enter Valid Mobile Number");
                this.loaderTab = false;
            } else {
                try {
                    this.userBasedReport = await new CorporateService().getUsageReportQuery({
                        mobile: this.mobile,
                        branchId: this.branchId,
                        fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                        toDate: moment(this.reportTo).format('YYYY-MM-DD')

                    });
                    if(this.userBasedReport.reportData.length > 0) {
                        this.totalRecords = this.userBasedReport.reportData.length;
                        (this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                        )),
                        (this.totalPages = new PaginationUtils().getTotalPages(
                            this.totalRecords,
                            this.pageRecords
                        ));
                        let to = this.pageRecords*this.pageNo;
                        let from = (this.pageRecords * (this.pageNo -1));
                        this.userBasedPageData = this.userBasedReport.reportData.slice(from, to)
                        this.displayUserBasedReport = true;
                        this.displayOverAllReport = false;
                        this.norecordsfound = false;
                        this.displayDownloadOption = true;
                    } else {
                        this.displayUserBasedReport = false;
                        this.displayOverAllReport = false;
                        this.norecordsfound = true;
                        this.displayDownloadOption = false;
                    }
                    this.loaderTab = false;
                } catch(error) {
                    this.loaderTab = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }   
            } 
        },
        async changeReportType(event) {
            let type = event.target.value;
            if(type == 'pdf') {
                if(this.displayOverAllReport) {
                    this.downloadPdf(this.overAllReport)
                } else {
                    this.downloadPdf(this.userBasedReport)
                }
            } else if(type == 'csv') {
                if(this.displayOverAllReport) {
                    this.downloadCSV(this.overAllReport)
                } else {
                    this.downloadCSV(this.userBasedReport)
                }
            }
        },
        async downloadCSV(reportDate) {
            try {
                jsonToCsvExport({ data: reportDate.downloadingReportData.csv,headers: reportDate.reportHeaders.csvHeader, filename: "UsageReport_"+moment().format("DD/MM/YYYY")+".csv" })  // Automatically triggers download
                this.reportType = ""
            } catch (error) {
                console.error('Error generating CSV:', error);
            }
        },
        async downloadPdf(data) {
            try {
                this.loaderTab = true;
                const response = await new CorporateService().downloadUsagePdfReport(data, this.branchId);
                 // Create a URL for the blob (PDF file)
                const pdfBlob = response.data;
                const pdfUrl = window.URL.createObjectURL(pdfBlob);
                var a = document.createElement("a");
                a.href = pdfUrl;
                a.setAttribute("download", "UsageReport_"+moment().format("DD/MM/YYYY")+".pdf");
                document.body.appendChild(a);
                a.click();
                a.remove();
                this.loaderTab = false;
                this.reportType = ""
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        async clearFields() {
            this.reportTo = new Date();
            if(this.mobile){
                document.getElementById("mobile").value = null;
                this.mobile = "";
                await this.getDateDaysAgo(this.configDays)
                await this.getDateMonthsAgo(this.configMonths)
                this.searchReport();
                this.reportType = ""
            }else {
                await this.getDateDaysAgo(this.configDays)
                await this.getDateMonthsAgo(this.configMonths)
                this.searchReport();
                this.reportType = ""
            }
            
        },
        async loadPage(page) {
            // localStorage.setItem("cpoReservationPage", page);
            // alert(page+ "--"+this.totalRecords+"--"+this.pageRecords)
            this.loaderTab = true;
            this.pageNo = page;
            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                page
            );
            let to = this.pageRecords*page;
            let from = (this.pageRecords * (page -1));
            
            if(this.mobile == '') {
                this.overAllPageData = this.overAllReport.reportData.slice(from, to);
            } else {
                this.userBasedPageData = this.userBasedReport.reportData.slice(from, to);
            }

            this.loaderTab = false;
        },
    },
})
</script>

<style scoped>
.btn-srch-clr{
    margin-top: 22px;
}
.export-report{
    width: 52%;
    margin-left: 20%;
}
.totalSection{
    /* background-color: #ededed; */
    margin-top: 20px;
    font-weight: bold;
}
.ext-link{
    color: black;
    cursor: auto;
}
</style>
